// extracted by extract-css-chunks-webpack-plugin
module.exports = {"limit-count":"_2psGiv","limit-count-warning":"_1TifmQ"};